export const infrastructureRouteEntries = {
  datacentersList: () => import('./presentation/DatacentersListPage'),
  datacenterForm: () => import('./presentation/DatacenterFormPage'),
  datacenterDetail: () => import('./presentation/DatacenterDetailPage'),
  salasList: () => import('./presentation/SalasListPage'),
  salaForm: () => import('./presentation/SalaFormPage'),
  salaDetail: () => import('./presentation/SalaDetailPage'),
  racksList: () => import('./presentation/RacksListPage'),
  rackForm: () => import('./presentation/RackFormPage'),
  rackDetail: () => import('./presentation/RackDetailPage'),
} as const;